import { render, staticRenderFns } from "./AddBtns.vue?vue&type=template&id=4db03cc4&scoped=true&"
import script from "./AddBtns.vue?vue&type=script&lang=js&"
export * from "./AddBtns.vue?vue&type=script&lang=js&"
import style0 from "./AddBtns.vue?vue&type=style&index=0&id=4db03cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db03cc4",
  null
  
)

export default component.exports